import { MuiThemeProvider } from '@material-ui/core';
import App from 'bnb-ui/dist/App';
import Header from 'bnb-ui/dist/Header';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import Main from '../../components/Main';
import MenuList from '../../components/MenuList';
import Out from '../../components/Out';
import User from '../../components/User';
import AcessoNegadoPage from '../../pages/AcessoNegado';
import { consultarTecnicosExternosPorEmail } from '../../provider/credenciada-service';
import ErrorBoundary from '../exceptions/ErrorBoundary';
import ExternOut from '../ExternOut';
import { init, keycloak } from './Auth';
import { updateUsuarioLogado } from '../../redux/actions';
import { connect } from 'react-redux';
import Manual from '../Manual';
import ModalVersao from '../ModalVersao';
import buildVersion from './../../buildVersion.json';

class Secured extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      keycloak: null,
      authenticated: false,
      isTecnicoExterno: false,
      validated: false,
      error: false,
      retorno: '',
      processed: false,
      validUser: null,
    };
    this.realizarLogout = this.realizarLogout.bind(this);
    this.validarUsuario = this.validarUsuario.bind(this);
  }
  componentDidMount() {
    if (keycloak) {
      init('login-required', 'hybrid')
        .success((authenticated) => {
          this.setState({ keycloak, authenticated });

          const username = this.state.keycloak.tokenParsed.preferred_username;
          sessionStorage.setItem('token', this.state.keycloak.token);
          sessionStorage.setItem('username', username);
          this.validarUsuario();
        })
        .error((err) => {
          throw new Error();
        });
    }
  }
  async validarUsuario() {
    let isTecnicoExterno = false;
    let validated = false;
    let error = false;
    if (this.state.processed) {
      return;
    }

    if (!this.state.authenticated || this.state.validated) {
      return;
    }
    try {
      const { updateUsuarioLogado } = this.props as any;
      const { validUser } = this.state;
      const responseTecnico = await consultarTecnicosExternosPorEmail();
      this.setState({ validUser: responseTecnico });
      updateUsuarioLogado(validUser.data);
      isTecnicoExterno = validUser.data.isTecnicoExterno;
      validated = validUser.data.isValidate;
    } catch {
      error = true;
      updateUsuarioLogado([]);
    }
    sessionStorage.setItem('isTecnicoExterno', isTecnicoExterno ? '1' : '0');
    this.setState((old) => ({
      ...old,
      isTecnicoExterno,
      validated,
      error,
      processed: true,
    }));
  }
  componentDidUpdate() {
    this.validarUsuario();
  }
  realizarLogout() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('isTecnicoExterno');
    sessionStorage.removeItem('username');

    updateUsuarioLogado([]);
    this.setState((old) => ({
      ...old,
      isTecnicoExterno: false,
      validated: false,
      authenticated: false,
    }));
    this.state.keycloak.logout({
      redirectUri: process.env.REACT_APP_NGINX_ENDPOINT || 'localhost:3000',
    });
  }
  render() {
    if (
      this.state.keycloak &&
      this.state.authenticated &&
      this.state.validated
    ) {
      return (
        <MuiThemeProvider theme={App}>
          <Header
            system="S610 - SISTEC"
            version={buildVersion.version}
            search={<Manual />}
            user={<User user={this.state.validUser.data} />}
            out={<Out realizarLogout={this.realizarLogout} />}
          >
            <MenuList />
            <ModalVersao open={false} />
          </Header>

          <ErrorBoundary {...this.props}>
            <Main />
          </ErrorBoundary>
        </MuiThemeProvider>
      );
    } else if (this.state.isTecnicoExterno) {
      return (
        <MuiThemeProvider theme={App}>
          <Header system="S610 - SISTEC" version={buildVersion.version} />
          <ExternOut realizarLogout={this.realizarLogout} />
        </MuiThemeProvider>
      );
    } else if (
      this.state.keycloak &&
      this.state.authenticated &&
      this.state.error
    ) {
      return <AcessoNegadoPage logout={this.realizarLogout} />;
    } else {
      return <div></div>;
    }
  }
}
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateUsuarioLogado }, dispatch);
export default connect(null, mapDispatchToProps)(Secured);
